export function validasiNameDate(item) {
  const {
    serviceName,
    nameService,
    service_display,
    service,
    rate_name,
    etd,
    etd_from,
    etd_thru,
    rate_id,
  } = item || {};

  const checkEtd =
    etd_from == null
      ? etd_thru
      : etd_thru == null
      ? etd_from
      : etd_from == etd_thru
      ? etd_thru
      : `${etd_from}-${etd_thru}`;
  const name =
    item?.provider?.toLowerCase() == "rajaongkir"
      ? rate_id
      : serviceName || nameService || service_display || service || rate_name;
  let date =
    (etd == "" || etd == null ? "" : `(${etd})`) ||
    (checkEtd == null ? "" : `(${checkEtd} hari)`);

  if (item?.provider?.toLowerCase() == "wahana") {
    date = `(${
      Number(item?.price?.leadTime) > 0
        ? `1 - ${item?.price?.leadTime}`
        : item?.price?.leadTime
    } hari)`;
  }

  return {
    name,
    date,
    field:
      item?.provider?.toLowerCase() == "rajaongkir"
        ? "rate_id"
        : serviceName
        ? "serviceName"
        : nameService
        ? "nameService"
        : service_display
        ? "service_display"
        : rate_name
        ? "rate_name"
        : "service",
  };
}
